import React, { useEffect, useState, useRef } from "react";

import ModelContainer from "./ModelContainer";

import Select from "./Select";
import Input from "./Input";
import Checkbox from "./Checkbox";
import DateInput from "./DateInput";
import TimeInput from "./TimeInput";
import MultiSelect from "./MultiSelect";

import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../Redux";
import { getFormData } from "../../helpers";

const DynamicModal = ({ modalInfo, setModalInfo }) => {
  //
  const counter = useRef(0);
  counter.current++;
  console.log(counter.current, "reRenders");
  //

  const dispatch = useDispatch();

  function getModalElement(elementInfo) {
    if (elementInfo.elementType === "input")
      return (
        <Input
          label={elementInfo.label}
          formRegister={modalRegister}
          formError={modalError}
          formKey={elementInfo.modalKey}
          isModal={true}
          type={elementInfo.inputType || "text"}
          {...elementInfo}
        />
      );

    if (elementInfo.elementType === "select") {
      return (
        <Select
          label={elementInfo.label}
          formRegister={modalRegister}
          formError={modalError}
          formKey={elementInfo.modalKey}
          isModal={true}
          optionsArray={elementInfo.optionsArray}
          onChange={(e) => {}}
          {...elementInfo}
        />
      );
    }
    if (elementInfo.elementType === "multiSelect") {
      return (
        <MultiSelect
          label={elementInfo.label}
          formRegister={modalRegister}
          formError={modalError}
          formKey={elementInfo.modalKey}
          optionsArray={elementInfo.optionsArray}
          onChange={(e) => {}}
          isModal={true}
          localStateValue={modalInfo.localStateValue}
          formFieldSetMethod={setValue}
          //
          dynamicModalElementInfo={elementInfo}
          setModalInfo={setModalInfo}
          dynamicModalInfo={modalInfo}
          {...elementInfo}
        />
      );
    }

    if (elementInfo.elementType === "date") {
      return (
        <DateInput
          label={elementInfo.label}
          formRegister={modalRegister}
          formError={modalError}
          formKey={elementInfo.modalKey}
          dateVal={elementInfo.localStateValue}
          //! NO NEED TO PASS THIS FUNCTION AS WE ARE NOT CREATING NEW STATE TO STORE DATE VALUE. WE ARE JUST CREATING A KEY IN ELEMENT INFO TO STORE IT.
          // setDateVal={elementInfo.setLocalStateMethod}
          // ! AND WE ARE UPDATING THE BY STATE UPLIFTING IN DATE COMPONENT
          setFormField={setValue}
          isModal={true}
          // PASSING THESE PROPS TO UPADTE VALUE IN
          dynamicModalElementInfo={elementInfo}
          setModalInfo={setModalInfo}
          dynamicModalInfo={modalInfo}
          {...elementInfo}
        />
      );
    }

    if (elementInfo.elementType === "time") {
      return (
        <TimeInput
          label={elementInfo.label}
          formRegister={modalRegister}
          formError={modalError}
          formKey={elementInfo.modalKey}
          timeVal={elementInfo.localStateValue}
          // setTimeVal={elementInfo.setLocalStateMethod}
          isModal={true}
          setFormField={setValue}
          dynamicModalElementInfo={elementInfo}
          setModalInfo={setModalInfo}
          dynamicModalInfo={modalInfo}
          {...elementInfo}
        />
      );
    }

    if (elementInfo.elementType === "checkbox") {
      return (
        <Checkbox
          type="checkbox"
          label={elementInfo.label}
          formRegister={modalRegister}
          formError={modalError}
          formKey={elementInfo.modalKey}
          isModal={true}
          setFormField={setValue}
          //
          localStateValue={elementInfo?.defaultValue}
          uncheckedValue={elementInfo?.uncheckedValue}
          checkedValue={elementInfo?.checkedValue}
          //
          dynamicModalElementInfo={elementInfo}
          setModalInfo={setModalInfo}
          dynamicModalInfo={modalInfo}
          {...elementInfo}
        />
      );
    }
  }

  const editModalDefaultState = modalInfo.editModalState;
  useEffect(() => {
    console.log(
      modalInfo.modalType === "edit",
      modalInfo.modalType,
      editModalDefaultState,
      "oooooooooooooooo"
    );
    if (modalInfo.modalType === "edit") modalReset(editModalDefaultState);
    else {
      modalReset(getAddModalDefaultState());
    }
  }, [editModalDefaultState, modalInfo?.modalType, modalInfo?.modalOpenState]);
  function getModalSchema() {
    const schemaObject = {};

    for (const modalElement of modalInfo.modalElements) {
      switch (modalElement?.dataType) {
        case "mixed":
          {
            if (modalElement?.isRequired)
              schemaObject[modalElement.modalKey] = yup
                .mixed()
                .test("file", "file is required", (value) => {
                  return value.length !== 0 && typeof value === "object";
                });
            else schemaObject[modalElement.modalKey] = yup.mixed();
          }
          break;

        case "array":
          {
            if (modalElement?.isRequired)
              schemaObject[modalElement.modalKey] = yup
                .array()
                .nullable()
                .required();
            else schemaObject[modalElement.modalKey] = yup.array();
          }
          break;

        default: {
          if (modalElement?.isRequired)
            schemaObject[modalElement.modalKey] = yup.string().required();
          else schemaObject[modalElement.modalKey] = yup.string();
        }
      }
    }
    const modalSchema = yup.object(schemaObject);
    return modalSchema;
  }

  function getAddModalDefaultState() {
    const addModalDefaultState = {};

    for (const modalElement of modalInfo.modalElements) {
      addModalDefaultState[modalElement?.modalKey] =
        modalElement?.defaultValue || "";
    }
    return addModalDefaultState;
  }
  const {
    register: modalRegister,
    formState: { errors: modalError },
    handleSubmit: modalSubmit,
    reset: modalReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(getModalSchema()),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      modalInfo.modalType === "add"
        ? getAddModalDefaultState()
        : editModalDefaultState,
  });

  const submitData = (data) => {
    console.log(data, "1111111");
    if (modalInfo.modalType === "add") {
      if (modalInfo.containsFile === true) {
        const formData = getFormData({ ...data, document: data.document[0] });
        dispatch(modalInfo?.postAddAction(formData));
      } else dispatch(modalInfo?.postAddAction(data));

      // run after dispatch
      modalInfo?.runAfterDispatch();
    } else {
      if (modalInfo.containsFile === true) {
        const formData = getFormData({
          ...data,
          document: data.document[0],
          ...modalInfo?.postExtraKeys,
        });
        dispatch(modalInfo?.editPostAction(formData));
      } else
        dispatch(
          modalInfo?.editPostAction({ ...data, ...modalInfo?.postExtraKeys })
        );
    }
  };

  return (
    <ModelContainer
      title={modalInfo.title}
      open={modalInfo.modalOpenState}
      closeModal={() => modalInfo.setModalOpenState(!modalInfo.modalOpenState)}
      submitModal={modalSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            {modalInfo.modalElements.map((elementInfo) =>
              getModalElement(elementInfo)
            )}
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};

export default React.memo(DynamicModal);
